
import Navbars from './components/Navbars';
import About from './components/About';
import React from 'react';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import FirstSection from './components/FirstSection';
import Applications from './components/Applications';
import Advantages from './components/Advantages';
import Boards from './components/Boards';
import Projects from './components/Projects';
import CookieConsent from './components/CookieConsent';

function App() {
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  const page = currentPath === '/boards' ? (
    <Boards />
  ) : (
    <div className="App">
      <Navbars />
      <FirstSection />
      <About />
      <Projects />
      <Applications />
      <Advantages />
      <ContactForm />
      <Footer />
    </div>
  );

  return (
    <>
      {page}
      <CookieConsent />
    </>
  );
}

export default App;
